export function processContentNewElement(newElement, getEmailUser) {
  let description = newElement.description;

  const types = ["duda", "desacuerdo", "acuerdo", "compromiso", "votación", 'votacion'];
  const type = types.find(t => description.toLowerCase().startsWith(t)) || "textoLibre";
  newElement.type = type;
  newElement.class = type;

  // Quitar tilde
  if(newElement.type === 'votación'){
    newElement.type = 'votacion';
  }

  // Extraer fecha en formato dd-mm-yyyy y convertir a yyyy-mm-dd
  const dateRegex = /\b(\d{2})-(\d{2})-(\d{4})\b/;
  const dateMatch = description.match(dateRegex);
  if (dateMatch) {
    const [day, month, year] = dateMatch.slice(1, 4);
    newElement.dateLimit = `${year}-${month}-${day}`;
  }

  // Extraer hora en formato hh:mm
  const timeRegex = /\b(\d{2}:\d{2})\b/;
  const timeMatch = description.match(timeRegex);
  if (timeMatch) {
    newElement.timeLimit = timeMatch[1];
  }

  // Obtener responsables
  const responsibleRegex = /@(\w+)/g;
  const responsibleMatches = [...description.matchAll(responsibleRegex)];

  if (responsibleMatches) {
    if (newElement.type === "compromiso" && responsibleMatches.length > 0) {
      newElement.responsable = responsibleMatches[0][1];
      newElement.participants = getEmailUser(responsibleMatches[0][1]);
    } else if (newElement.type === "desacuerdo") {
      if (responsibleMatches.length === 2) {
        newElement.disagreement.secondPosition.responsible =
          responsibleMatches[1][1];
      }
      if (responsibleMatches.length >= 1) {
        newElement.disagreement.firstPosition.responsible =
          responsibleMatches[0][1];
      }
    }
  }
}